module.exports = __webpack_public_path__ + "static/media/adesivo_northin.848c67d6.png";